import { xlColq } from "./constants";

export function getDateHeaders(fromDate, toDate) {
  const headers = [];
  const current = new Date(fromDate);
  current.setHours(0, 0, 0, 0);
  toDate = new Date(toDate);
  toDate.setHours(0, 0, 0, 0);

  while (current <= toDate) {
    headers.push({
      day: current.getDate(),
      month: current.getMonth(),
      year: current.getFullYear(),
      xlCol: xlColq,
    });

    current.setDate(current.getDate() + 1);
  }

  return headers;
}

export function getPastMonthHeaders(range, includeCurrent = false) {
  const headers = [];
  const today = new Date();
  const offset = includeCurrent ? range - 1 : range;
  const start = new Date(today.getFullYear(), today.getMonth() - offset, 1);
  for (let i = 0; i < range; i++) {
    const date = new Date(start.getFullYear(), start.getMonth() + i, 1);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    headers.push({ month, year });
  }

  return headers;
}

export const normalizeDate = (d) => {
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};
export const formatDate = (d) => {
  const date = new Date(d);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
export function getCurrentDateTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
